import React, { useContext, useEffect } from 'react';
import Welcome from '../Welcome Screen';
import ApplicationContext from '../../context/ApplicationContext';
import NamePage from '../Authentication/NamePage';
import DOBPage from '../Authentication/DOBPage';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import Appointments from '../Appointments';
import AppointmentOptions from '../Appointments/AppointmentOptions';
import IdentityDocument from '../IdentityDocument';
import CancelAppointment from '../Appointments/CancelAppointment';
import ThankYou from '../ThankYou';
import RescheduleAppointment from '../Appointments/RescheduleAppointment';
import InsuranceDocuments from '../InsuranceDocuments';
import IdentificationDetails from '../IdentityDocument/IdentificationDetails';
import PhotoChoice from '../IdentityDocument/PhotoChoice';
import UploadPhoto from '../IdentityDocument/UploadPhoto';
import TakePhoto from '../IdentityDocument/TakePhoto';
import InsuranceDetails from '../InsuranceDocuments/InsuranceDetails';
import InsurancePhotoChoice from '../InsuranceDocuments/InsurancePhotoChoice';
import UploadInsurancePhoto from '../InsuranceDocuments/UploadInsurancePhoto';
import Documents from '../Documents';
import TakeInsuranceFrontPhoto from '../InsuranceDocuments/TakeInsuranceFrontPhoto';
import TakeInsuranceBackPhoto from '../InsuranceDocuments/TakeInsuranceBackPhoto';
import Review from '../Review';
import ChooseLanguage from '../ChooseLanguage';
import SignatureSection from '../Documents/DocumentLoad/Signature';

function Main(props) {
    const { currentPage } = useContext(ApplicationContext);

    const handleUI = () => {
        let ui;
        switch(currentPage) {
        case 'welcome': ui = <Welcome />
            break;
        case 'nameVerify': ui = <NamePage />
            break;
        case 'dobVerify': ui = <DOBPage />
            break;
        case 'appointments': ui = <Appointments />
            break;
        case 'appointment_options': ui = <AppointmentOptions />
            break;
        case 'identity': ui = <IdentityDocument />
            break;
        case 'cancel': ui = <CancelAppointment />
            break;
        case 'thankyou': ui = <ThankYou />
            break;
        case 'reschedule': ui = <RescheduleAppointment />
            break;
        case 'insurance': ui = <InsuranceDocuments />
            break;
        case 'card_details': ui = <IdentificationDetails />
            break;
        case 'upload_id_choice': ui = <PhotoChoice />
            break;
        case 'upload_id_image': ui = <UploadPhoto />
            break;
        case 'take_id_image': ui = <TakePhoto />
            break;
        case 'insurance_details': ui = <InsuranceDetails />
            break;
        case 'upload_insurance_choice': ui = <InsurancePhotoChoice />
            break;
        case 'upload_insurance_images': ui = <UploadInsurancePhoto />
            break;
        case 'documents': ui = <Documents />
            break;
        case 'take_insurance_front_image': ui = <TakeInsuranceFrontPhoto />
            break;
        case 'take_insurance_back_image': ui = <TakeInsuranceBackPhoto />
            break;
        case 'review': ui = <Review />
            break;
        case 'choose_language': ui = <ChooseLanguage />
            break;
        case 'signature': ui = <SignatureSection />
            break;
        }
        return ui;
    }
    
    return (
        <AnimatedPageFade>
            {handleUI()}
        </AnimatedPageFade>
    );
}

export default Main;